import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "./FeaturedProducts.css";

const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    fetch("https://nazarenterprise.com/nazar-admin/api/add-to-home.php")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.products || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const openModal = (product) => {
    setSelectedProduct(product);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedProduct(null);
    document.body.style.overflow = "unset";
  };

  if (loading) {
    return (
      <section className="featured-section">
        <div className="featured-container">
          <h2 className="section-title">Featured Marine & Ship Equipment</h2>
          <p className="loading-text">Loading premium products...</p>
        </div>
      </section>
    );
  }

  if (!products.length) return null;

  return (
    <>
      <section className="featured-section">
        <div className="featured-container">
          <div className="header-text">
            <h2 className="section-title">Featured Marine & Ship Equipment</h2>
            <p className="section-subtitle">
              Premium Quality Products Trusted by Global Shipping Leaders
            </p>
          </div>

          {/* ===== SWIPER SLIDER ===== */}
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              el: ".swiper-custom-dots",
              bulletClass: "custom-dot",
              bulletActiveClass: "custom-dot-active",
            }}
            spaceBetween={28}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <div className="slide-item">
                  <div className="product-card-feature">
                    <div className="image-wrapper">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="product-image"
                        loading="lazy"
                      />
                      <div className="image-overlay" />
                    </div>

                    <div className="content">
                      <h3 className="product-title">{product.title}</h3>
                      <p className="product-desc-short">
                        {product.des
                          .replace(/<[^>]*>/g, "")
                          .substring(0, 100)}
                        ...
                      </p>
                      <button
                        className="cta-btn"
                        onClick={() => openModal(product)}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom dots container */}
          <div className="swiper-custom-dots" />
        </div>
      </section>

      {/* ===== MODAL (UNCHANGED) ===== */}
      {selectedProduct && (
        <div
          className="product-modal-overlay"
          onClick={(e) =>
            e.target === e.currentTarget && closeModal()
          }
        >
          <div className="product-modal">
            <button className="modal-close-btn" onClick={closeModal}>
              ×
            </button>

            <div className="modal-content-grid mobile">
              <div className="modal-image-wrapper mobile-image-wrapper">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.title}
                  className="modal-product-image"
                />
              </div>

              <div className="modal-details">
                <h2 className="modal-product-title">
                  {selectedProduct.title}
                </h2>
                <div
                  className="modal-product-desc"
                  dangerouslySetInnerHTML={{
                    __html: selectedProduct.des,
                  }}
                />
                <a href="/contact" className="contact-us-btn">
                  Contact Us for Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FeaturedProducts;
